import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { FormHome } from '../../forms';
import { addHome } from '../../../../data/Homes/actions';
import getSelectors from '../../selectors';

class Step3 extends PureComponent {
    static propTypes = {
        homeForm: PropTypes.object.isRequired,
        saveHome: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
    }

    render() {
        const { homeForm, saveHome } = this.props;
        return <FormHome sendDataFunc={saveHome} stepHomeForm={homeForm} type="add" />;
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const selectors = getSelectors(history.environment);
    return {
        profile: selectors.getProfile(state)
    };
}

export default withRouter(
    renderEnvComponent(
        'scenes/Home/components/stepper/Step3',
        connect(
            mapStateToProps,
            (dispatch, ownProps) => bindActionCreators(tools.mergePropsToAction(ownProps.history.environment, { addHome }), dispatch)
        )(Step3)
    )
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Home/components/stepper/Step3.js